import { Injectable } from '@angular/core';
import { ApiInvoiceGroup, PostBatchFilters } from '@app/infrastructure/api/models';
import { ROWS_PER_PAGE_OPTIONS } from '@app/shared/common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetPostBatchListConfig } from './_actions';
import { PostBatchStatusTab } from './_models';

export const CURRENT_POST_BATCH_LIST_VERSION = 4;

interface PostBatchStateModel {
  version: number;
  itemsPerPage: number;
  searchText?: string;
  invoiceGroup?: ApiInvoiceGroup;
  filters?: PostBatchFilters;
  statusTab?: PostBatchStatusTab;
}

export const POST_BATCH_STATE_DEFAULTS: PostBatchStateModel = {
  version: CURRENT_POST_BATCH_LIST_VERSION,
  itemsPerPage: ROWS_PER_PAGE_OPTIONS[0],
};

@State<PostBatchStateModel>({
  name: 'PostBatchList',
  defaults: POST_BATCH_STATE_DEFAULTS,
})
@Injectable()
export class PostBatchListState {
  @Selector()
  static itemsPerPage(state: PostBatchStateModel): number {
    return state.itemsPerPage;
  }

  @Selector()
  static searchText(state: PostBatchStateModel): string | undefined {
    return state.searchText;
  }

  @Selector()
  static invoiceGroup(state: PostBatchStateModel): ApiInvoiceGroup | undefined {
    return state.invoiceGroup;
  }

  @Selector()
  static filters(state: PostBatchStateModel): PostBatchFilters | undefined {
    return state.filters;
  }

  @Selector()
  static statusTab(state: PostBatchStateModel): PostBatchStatusTab | undefined {
    return state.statusTab;
  }

  @Action(SetPostBatchListConfig)
  setPostBatchListConfig(ctx: StateContext<PostBatchStateModel>, action: SetPostBatchListConfig) {
    ctx.patchState({
      ...(action.config.itemsPerPage !== undefined && { itemsPerPage: action.config.itemsPerPage }),
      ...(action.config.searchText !== undefined && {
        searchText: action.config.searchText || undefined,
      }),
      ...(action.config.invoiceGroup !== undefined && {
        invoiceGroup: action.config.invoiceGroup,
      }),
      ...(action.config.filters !== undefined && {
        filters: action.config.filters || undefined,
      }),
      ...(action.config.statusTab !== undefined && {
        statusTab: action.config.statusTab ?? undefined,
      }),
    });
  }
}
